import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

let versionUI = localStorage.getItem("versionUI");
if (!versionUI) {
  versionUI = "new";
  localStorage.setItem("versionUI", "new");
}

const routes = [
  {
    path: "/todo",
    name: "zaloTodoPage",
    component: () => import(/* webpackChunkName: "Setting" */ "./pages/ZaloToDoPage")
  },
  {
    path: "/",
    name: "Conversation",
    component: () => import(/* webpackChunkName: "ShoppeAccount" */ "./pages/ConversationPageV2"),
    alias: ["/conversation"]
  },
  {
    path: "/setting",
    name: "Setting",
    component: () => import(/* webpackChunkName: "Setting" */ "./pages/Setting")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "Setting" */ "./pages/Contact")
  },
  {
    path: "/statistical",
    name: "statistical",
    component: () => import(/* webpackChunkName: "Setting" */ "./pages/Statistical")
  },
  {
    path: "/account",
    name: "AccountManagementPage",
    component: () => import(/* webpackChunkName: "AccountManagement" */ "./components/AccountManagement")
  },
  {
    path: "/loginZaloV2",
    name: "LoginV2",
    component: () => import(/* webpackChunkName: "AccountManagement" */ "./components/loginV2/LoginV2")
  },
  // {
  //   path: "/marketing-message",
  //   name: "Marketing Message",
  //   component: () => import(/* webpackChunkName: "Setting" */ "./pages/MarketingMessage")
  // },
  // {
  //   path: "/scheduler-message",
  //   name: "Scheduler Message",
  //   component: () => import(/* webpackChunkName: "Setting" */ "./pages/SchedulerMessage")
  // }
  {
    path: "/v1/conversation",
    name: "ConversationV1",
    component: () => import(/* webpackChunkName: "ShoppeAccount" */ "./pages/ConversationPage"),
    alias: ["/conversationv1"]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
